import { NavLink } from 'react-router-dom';
import isEqual from 'lodash.isequal';
import { Controller } from 'react-hook-form';
import { InputText, Select } from '@ui/src';
import FeeBlock from './fee-form-block';
import FeeAttributes from './fee-attributes';
// import FeeLog from './fee-log';
import { CustomerStatus, FeeTypeEnum } from '../../../hoc/customers/types';
import { FeeTypes } from './types';

import cn from './tariffs.module.css';

const FeeForm = ({
  feeTypes,
  control,
  errors,
  onClose,
  feeId,
  // logs,
  link,
  values,
  isModified,
  onRestoreDefault,
  isEditable,
  defaultFormValues,
  currencies,
  regularFee,
  baseCurrency,
  feeCurrencyId,
  feeCascadeCurrenciesIds,
  status,
  setValue,
}: FeeTypes) => {
  const currentFeeType = feeTypes?.find((item) => item.id === values?.feeType);

  return (
    <div>
      {values?.feeType &&
        currentFeeType &&
        currentFeeType.feeType === FeeTypeEnum.MANUAL &&
        feeId && (
          <NavLink
            to={link as string}
            className={cn.feeFormTransactionLink}
            onClick={() => setTimeout(() => onClose(), 300)}
          >
            Write-off funds from fee
          </NavLink>
        )}
      {/* {logs && <FeeLog logs={logs} />} */}
      <FeeBlock title="Fee name">
        <Controller
          control={control}
          name="name"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <InputText
              name="name"
              placeholder="Enter Fee Name"
              title=""
              onChange={onChange}
              value={value}
              error={errors?.name?.message}
              disabled={Boolean(feeId) || status === CustomerStatus.CLOSED}
            />
          )}
        />
      </FeeBlock>
      <FeeBlock title="Fee type">
        <Controller
          control={control}
          name="feeType"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <Select
              name="feeType"
              title=""
              placeholder="Select type..."
              onChange={onChange}
              value={value}
              list={
                feeTypes?.map((item) => ({
                  name: item.name,
                  value: item.id,
                })) || []
              }
              disabled={Boolean(feeId) || status === CustomerStatus.CLOSED}
              selectWrapperClassName={cn.feeTypeSelect}
              fullWidth
            />
          )}
        />
      </FeeBlock>
      <FeeBlock
        title="Fee attributes"
        buttonDisabled={isEqual(values, defaultFormValues)}
        onClick={onRestoreDefault}
        withButton={isEditable}
        isModified={isModified}
      >
        {!values?.feeType ? (
          <div className={cn.createFeeAttributesHint}>
            First choose the fee type
          </div>
        ) : (
          <FeeAttributes
            control={control}
            errors={errors}
            feeAmountType={values.feeAmountType}
            isEditable={isEditable}
            baseCurrency={baseCurrency}
            currencies={currencies}
            regularFee={regularFee}
            feeCascadeCurrenciesIds={feeCascadeCurrenciesIds}
            feeCurrencyId={feeCurrencyId}
            setValue={setValue}
            status={status}
          />
        )}
      </FeeBlock>
    </div>
  );
};

export default FeeForm;
